<template>
  <transition name="router-anim">
    <div class="kits">
      <div class="top-panel">
        <DescriptionModal class="description-modal"
          :description="`This page displays a list of MCTlab users.`" />
      </div>
      <div class="kits-title">
        <div class="title first-name">
          FIRST NAME
        </div>
        <div class="title last-name">
          LAST NAME
        </div>
        <div class="title email">
          EMAIL
        </div>
        <div class="title date">
          REGISTRATION DATE
        </div>
      </div>
      <div v-if="mtcLabUsers.length > 0">
        <div class="kits-item" v-for="item in mtcLabUsers" :key="item.id">
          <div class="kit-desc first-name">
            {{ item.first_name }}
          </div>
          <div class="kit-desc last-name">
            {{ item.last_name }}
          </div>
          <div class="kit-desc email">
            <span>{{ item.email }}</span>
          </div>
          <div class="kit-desc date">
            {{ date(item.created_at) }}
          </div>
          <button
            title="Delete"
            class="remove-icon-btn"
            @click="remove(item.id, item.first_name, item.last_name)"
          >
            <Remove></Remove>
          </button>
        </div>
      </div>
      <div v-else class="kits-item">
        <div class="kit-desc nodata">
          No Data Retrieved.
        </div>
      </div>
      <div class="pogination">
        <Paginate
          v-if="count_page > 1"
          :page-count="count_page"
          :page-class="'pogination-item'"
          :click-handler="changePage"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pogination-wrap'"
        ></Paginate>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Paginate from "vuejs-paginate";
import Remove from "../../images/dashboard/Remove";

export default {
  name: "MtcLabUsers",
  data() {
    return {
      mtcLabUsers: [],
      count_page: 1,
    };
  },
  components: {
    Remove,
    Paginate
  },
  methods: {
    ...mapActions([
      "getMtcLabUserInfoList",
      "removeMtcLabUser"
    ]),
    changePage(item) {
      this.getMtcLabUserInfoList({ page: item });
    },
    remove(id, firstName, lastName) {
      if (confirm(`Are you sure you want to delete ${firstName} ${lastName}?`)) {
        this.removeMtcLabUser(id).then(() => {
          this.getMtcLabUserInfoList("mtcLab");
        });
      }
    },
    date(localDate) {
      return localDate;
    }
  },
  computed: {
    ...mapGetters(["getMtcLabUsers", "getMtcLabPagination"])
  },
  watch: {
    getMtcLabUsers(obj) {
      if (obj) {
        this.mtcLabUsers = obj;
      }
    },
    getMtcLabPagination(obj) {
      if (obj) {
        this.count_page = obj.lastPage;
      }
    }
  },
  mounted() {
    const users = this.$store.getters.getMtcLabUsers;
    if (users) {
      this.mtcLabUsers = users;
    }
    const pagination = this.$store.getters.getMtcLabPagination;
    if (pagination) {
      this.count_page = pagination.lastPage;
    }
  }
};
</script>

<style scoped>
.kits {
  margin: 40px 0 0 0;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 30px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.title.first-name {
  min-width: 300px;
  width: 100%;
}
.kit-desc.first-name {
  min-width: 300px;
  width: 100%;
}
.title.last-name {
  min-width: 300px;
  width: 100%;
}
.kit-desc.last-name {
  min-width: 300px;
  width: 100%;
}
.title.email {
  min-width: 320px;
  width: 100%;
}
.kit-desc.email {
  min-width: 320px;
  width: 100%;
}
.kit-desc.email span {
  overflow: hidden;
  width: 98%;
  display: inline-block;
}
.title.date {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  position: relative;
}
.kit-desc.date {
  padding: 0 20px 0 0;
  min-width: 160px;
  width: 100%;
}
.kits-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kit-desc {
  color: #58595b;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  width: 10px;
}
.pogination {
  margin: 20px 0 0 0;
}
.kit-desc.nodata {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}
.top-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 30px;
}
.description-modal {
  text-align: end;
  position: absolute;
  z-index: 1;
  width: 100%;
}
</style>
